import { Spinner as SpinJsSpinner, type SpinnerOptions } from "spin.js";

const spinnerOptions = {
	lines: 13,
	length: 15,
	width: 2,
	radius: 20,
	corners: 0,
	speed: 1,
	trail: 50,
	hwaccel: true,
	color: "#a6192e"
};

import { Vue, Component, Prop, Watch } from "@wagich/vue-facing-decorator-metadata";
import { h } from "vue";

@Component({
	render: function (this: Spinner) {
		return this.modelValue ? h("span") : null;
	},
})
export class Spinner extends Vue {
	@Prop({ required: false, default: false }) modelValue: boolean;
	spinner: SpinJsSpinner;

	@Watch("modelValue")
	async onModelValueChanged(newValue: boolean) {
		await this.$nextTick();
		if (newValue) {
			this.spinner.spin(this.$el as HTMLElement);
		} else {
			this.spinner.stop();
		}
	}

	created() {
		this.spinner = new SpinJsSpinner(spinnerOptions);
	}

	mounted() {
		this.onModelValueChanged(this.modelValue);
	}

	beforeUnmount() {
		this.spinner.stop();
	}
}
